export const FALLBACK_TOP = "clamp(56px, 10vh, 120px)";
export const FALLBACK_BOTTOM = "clamp(32px, 8vh, 96px)";

export function normalizePx(value) {
  if (value === 0 || value === "0") return "0px";
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? `${n}px` : null;
}

export function addCustomPadding({
  customEnabled = false,
  topPx,
  bottomPx,
  fallbackTop = FALLBACK_TOP,
  fallbackBottom = FALLBACK_BOTTOM,
} = {}) {
  const style = {};
  const classes = [];

  if (customEnabled) {
    const top = normalizePx(topPx);
    const bottom = normalizePx(bottomPx);
    style.paddingTop = top ?? fallbackTop;
    style.paddingBottom = bottom ?? fallbackBottom;
    classes.push("has-custom-padding");
  } else {
    style.paddingTop = fallbackTop;
    style.paddingBottom = fallbackBottom;
  }

  return { style, className: classes.join(" ") };
}
